"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsSlice = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _status = require("./status");
const initialState = {
  values: {},
  status: _status.translationsStatus.INACTIVE,
  errorMessage: null
};
const translationsSlice = exports.translationsSlice = (0, _toolkit.createSlice)({
  name: 'translations',
  initialState,
  reducers: {
    startLoading: state => {
      state.status = _status.translationsStatus.PENDING;
      state.errorMessage = null;
    },
    loadSuccess: (state, action) => {
      state.status = _status.translationsStatus.SUCCESS;
      state.errorMessage = null;
      state.values = action.payload;
    },
    loadFailure: (state, action) => {
      state.status = _status.translationsStatus.ERROR;
      state.errorMessage = action.payload;
    }
  }
});